import React from 'react'
import moment from 'moment'
import _ from 'lodash'

class CalendarInputField extends React.Component {
	/* This component is responsible for allowing users to input assignment 'queue on' date
    by manually entering values in mm/dd/yyyy format. 
  */
	constructor(props) {
		super(props)
		this.state = {
			textInput: '',
			cachedDate: ''
		}
	}

	/*Check if the new input date is same as the cachedDate, if not, then update the state on
    cached date to be the input date. This check should happen, when the component updates
  */
	componentDidUpdate() {
		this.checkForSelectedDateChange()
	}

	checkForSelectedDateChange = () => {
		if (!_.isEqual(this.props.input.value, this.state.cachedDate)) {
			this.props.updateValue(this.props.input.name, this.props.input.value)
			this.setState({ textInput: this.props.input.value, cachedDate: this.props.input.value })
		}
	}

	updateTextField = e => {
		this.setState({ textInput: e.target.value })
		if (moment(e.target.value, 'M/D/YYYY', true)._isValid) {
			this.props.input.onChange(e)
		}
	}

	getLabel = () =>
		this.props.label && (
			<label htmlFor={this.props.input.id || this.props.input.name}>{this.props.label}</label>
		)

	isFirstInput = new RegExp(/\d+/g).exec(this.props.input.name)[0] == '0'

	render() {
		const { value, name, placeholder, hidden, input, label, wrapperClass, type, isNew, meta } =
			this.props
		return (
			<div className={`${type} ${wrapperClass} input form-group form-group-default`}>
				{this.getLabel()}
				<input
					className={`form-control no-box-shadow`}
					value={this.state.textInput}
					id={input.name}
					type={type}
					placeholder={placeholder}
					onChange={this.updateTextField}
					onFocus={input.onFocus}
					autoFocus={this.isFirstInput}
					name={input.name}
				/>
			</div>
		)
	}
}
export default CalendarInputField
